import { t as e } from "./AppLocales-BhP8HhaO.js";
//#region src/constants/AppPaths.ts
var t = {
	home: "/",
	projects: "/projects",
	signIn: "/sign-in",
	signUp: "/sign-up",
	onboardingWorkspace: "/onboarding/workspace",
	settingsProfile: "/settings/profile",
	settingsSecurity: "/settings/security",
	settingsAppearance: "/settings/appearance",
	settingsWorkspace: "/settings/workspace",
	settingsMembers: "/settings/members",
	settingsBilling: "/settings/billing"
}, n = "EUR", r = [
	{
		key: "free",
		monthlyPriceInCents: 0,
		yearlyPriceInCents: 0,
		memberLimit: 3,
		isHighlighted: !1
	},
	{
		key: "pro",
		monthlyPriceInCents: 1200,
		yearlyPriceInCents: 12e3,
		memberLimit: 20,
		isHighlighted: !0
	},
	{
		key: "business",
		monthlyPriceInCents: 2900,
		yearlyPriceInCents: 29e3,
		memberLimit: null,
		isHighlighted: !1
	}
], i = "Neatship", a = "en", o = [
	"org:projects:create",
	"org:projects:update",
	"org:projects:delete",
	"org:workspace:manage",
	"org:billing:manage"
];
//#endregion
export { e as APP_LOCALES, t as APP_PATHS, r as PLANS, n as PLAN_CURRENCY, i as PRODUCT_NAME, a as SOURCE_LOCALE, o as WORKSPACE_PERMISSIONS };

//# sourceMappingURL=constants.mjs.map